<template>
	<div
		v-if="authStore.userReturned"
		class="app">
		<Navigation
			v-if="!route.meta.noNavigation && authStore.user"
			permanent />
		<main>
			<Suspense>
				<RouterView :key="route.path" />
			</Suspense>
		</main>
		<Toast position="bottom-right" />
		<ConfirmDialog></ConfirmDialog>
	</div>
	<div
		v-else-if="authStore.userError"
		class="app-error"
		role="alert">
		<p class="app-error__text">
			Povezava s strežnikom ni uspela. Preverite povezavo in poskusite znova.
		</p>
		<Button
			label="Poskusi znova"
			@click="reload" />
	</div>
	<ProgressSpinner
		v-else
		aria-label="Nalaganje"
		class="app-loader" />
</template>

<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router'
import Navigation from '@/components/Navigation.vue'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import { useAuth } from './composables/useAuth'
import ProgressSpinner from 'primevue/progressspinner'
import Button from 'primevue/button'

const { authStore } = useAuth()
const route = useRoute()

// The signed-in user could not be loaded (not a sign-out): start the app again.
function reload() {
	window.location.reload()
}
</script>

<style scoped lang="scss">
.app {
	display: flex;
	flex-direction: row;
	height: 100vh;
	width: 100%;
	justify-content: center;
	max-height: 100vh;
	overflow: auto;

	main {
		flex: 1;
		max-height: 100vh;
		overflow: auto;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
}

.app-error {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 16px;
	min-height: 100vh;
	padding: 24px;
	text-align: center;

	.app-error__text {
		margin: 0;
		max-width: 32rem;
	}
}

.app-loader {
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
</style>
